module.exports = __webpack_public_path__ + "static/cargador-coche-electrico-a53e3082f33b0ba494ab3475485416b2.jpg";